// Attribution: https://github.com/mui-org/material-ui/tree/next/docs/src/pages/getting-started/templates/dashboard

// Dependencies
import React from 'react';
import { Link } from 'react-router';

// MSAL
import { msalInstance } from "index.js";

// Material
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Tooltip from '@mui/material/Tooltip';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';

// Global Components
import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';

const MainMenuListItems = () => {
	const account = msalInstance.getActiveAccount();

	if (!account) return null;

	return (
		<Box>
			<ListItem component={Link} to="/home">
				<ListItemIcon>
					<Tooltip title="Home" placement="right" arrow>
						<HomeIcon />
					</Tooltip>
				</ListItemIcon>
				<ListItemText primary="Home" />
			</ListItem>
		</Box>
	);
};

const SecondaryMenuListItems = () => {
	const account = msalInstance.getActiveAccount();

	// user clicked on auth menu icon
	// this then calls the click on the auth button beside the icon
	const onAuthMenuItemClick = (event) => {
		event.preventDefault();
		//event.currentTarget.closest("button").click();
		document.querySelector('#authMenuItem button').click();
	};

	return (
		<div>
			{account ? (
				<>
					<ListSubheader component="div" inset>Links</ListSubheader>
					<ListItem component={Link} to="/profile">
						<ListItemIcon>
							<Tooltip title="My Profile" placement="right" arrow>
								<PersonIcon />
							</Tooltip>
						</ListItemIcon>
						<ListItemText primary="My Profile" />
					</ListItem>
					<ListItem component={Link} to="/settings">
						<ListItemIcon>
							<Tooltip title="Settings" placement="right" arrow>
								<SettingsIcon />
							</Tooltip>
						</ListItemIcon>
						<ListItemText primary="Settings" />
					</ListItem>
					<ListItem component={Link} to="/about">
						<ListItemIcon>
							<Tooltip title="About" placement="right" arrow>
								<InfoIcon />
							</Tooltip>
						</ListItemIcon>
						<ListItemText primary="About" />
					</ListItem>
				</>
			) : null}

			<ListItem id="authMenuItem" component="div">
				<ListItemIcon onClick={onAuthMenuItemClick} >
					{account
						? (
							<Tooltip title="Sign Out" placement="right" arrow>
								<LockOpenIcon />
							</Tooltip>)
						: (
							<Tooltip title="Sign In" placement="right" arrow>
								<LockIcon />
							</Tooltip>
						)}
				</ListItemIcon>
				{account ? <SignOutButton /> : <SignInButton />}
			</ListItem>

		</div>
	);
};

export {
	MainMenuListItems,
	SecondaryMenuListItems
}
